import { MutationTree } from "vuex";
import { API_PEDIDO } from "./types";

type FinalizarPedidoMutationTree = MutationTree<API_PEDIDO>;

export const mutations: FinalizarPedidoMutationTree = {};
